"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapContainer = void 0;
const react_1 = __importStar(require("react"));
function MapContainer(ref, onMountChange) {
    let initialized = false;
    return (props) => {
        return (react_1.default.createElement("div", { style: {
                ...props.style,
                overflow: "hidden",
                width: "100%",
                height: "100%"
            } },
            react_1.default.createElement("div", { style: { position: "relative", height: "100%" } },
                react_1.default.createElement("div", { ref: ref, style: {
                        position: "absolute",
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        overflow: "hidden"
                    } }),
                react_1.default.createElement("div", { style: {
                        position: "absolute",
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        pointerEvents: "none",
                        zIndex: 500
                    } }, react_1.Children.map(props.children, (child, i) => (0, react_1.cloneElement)(child, {
                    style: {
                        ...child.props.style,
                        pointerEvents: "auto"
                    }
                }))),
                react_1.default.createElement("div", { ref: (node) => {
                        if (!node)
                            return;
                        if (initialized)
                            return;
                        initialized = true;
                        if (ref.current === null)
                            return;
                        onMountChange(ref.current);
                    } }))));
    };
}
exports.MapContainer = MapContainer;
